module.exports = CONFIG;


//////////////////
// WEBPACK FOOTER
// external "CONFIG"
// module id = 551
// module chunks = 4